import React, { ReactNode, ReactNodeArray, FC } from 'react'
// libs
import cx from 'classnames'
// components
import Message from 'components/Form/Message'
// types
import { Classes } from 'jss'
import { WrappedFieldMetaProps } from 'redux-form'
// styles
import injectSheet from 'react-jss'
import { fieldsClasses } from './sheet'
import { TitleField } from './FieldWrapper'

interface Props {
  id: string
  children?: ReactNodeArray | ReactNode
  meta?: WrappedFieldMetaProps
  title?: string
  for?: string
  classes: Classes
  customClasses?: Classes | string
  required?: boolean
}

const Layout: FC<Props> = ({ classes, children, id, meta, title, customClasses, required }) => (
  <div className={cx(classes.inputRow, customClasses)}>
    {title && <TitleField id={id} title={title} required={required} />}
    <div className={classes.inputRoot}>{children}</div>
    {meta && <Message meta={meta} />}
  </div>
)

export default injectSheet(fieldsClasses)(Layout)
